import { IconCaretDownFilled, IconCirclePlus, IconPlus } from '@tabler/icons-react-native';
import { Box, Text, useTheme } from 'app/shopify/theme';
import { NavigationPressable, type NavigationState } from './NavigationPressable';

export interface PublishAction {
  label: string;
  onPress: () => void;
  disabled?: boolean;
  state?: NavigationState;
}

export function PublishButton({
  label,
  onPress,
  disabled,
  state,
  placement,
}: PublishAction & { placement: 'bottom' | 'header' }) {
  const theme = useTheme();
  const header = placement === 'header';
  const size = Number(theme.tokens.sizing[header ? 'sizing.icon.default' : 'sizing.icon.lg']);
  const color =
    theme.colors[
      header ? 'white-label.publish-button.icon.header-bar' : 'white-label.publish-button.icon.mobile-bottom-tab-bar'
    ];
  const Icon = header ? IconCirclePlus : IconPlus;
  return (
    <NavigationPressable
      accessibilityLabel={label}
      onPress={onPress}
      disabled={disabled}
      state={state}
      brand
      style={{
        maxWidth: '100%',
        minHeight: Number(
          theme.tokens.sizing[
            header ? 'sizing.component.button.height.large' : 'sizing.component.button.height.large-icn-button'
          ],
        ),
        width: header ? undefined : Number(theme.tokens.sizing['sizing.component.button.height.large-icn-button']),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: header ? theme.spacing['spacing.general.x6'] : 0,
        paddingVertical: header ? theme.spacing['spacing.general.x4'] : 0,
        borderRadius: theme.borderRadii[header ? 'radius.full' : 'radius.component.publish-button.button-radius'],
        backgroundColor:
          theme.colors[
            header ? 'white-label.publish-button.bg.header-bar' : 'white-label.publish-button.bg.mobile-bottom-tab-bar'
          ],
      }}
    >
      <Icon size={size} color={color} strokeWidth={2} />
      {header && (
        <>
          <Box paddingHorizontal="spacing.general.x2" paddingBottom="spacing.general.x0,5" flexShrink={1}>
            <Text variant="bodyBaseMedium" color="white-label.publish-button.label.primary">
              {label}
            </Text>
          </Box>
          <IconCaretDownFilled size={size} color={color} />
        </>
      )}
    </NavigationPressable>
  );
}
